<template>
  <myDrawer :isDrawer="isDrawer" :isFooter="true" :title="'标签数据'" @drawerClose="drawerClose">
    <template slot="content">
        <el-form :model="dataForm" ref="dataForm" label-width="80px" :rules="rules">
            <el-form-item label="标签值" prop="bqValue">
                <el-input v-model="dataForm.bqValue" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="标签名称" prop="bqLabel">
                <el-input v-model="dataForm.bqLabel" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="业务表" prop="dbTable">
                <el-input v-model="dataForm.dbTable" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input-number v-model="dataForm.sort" placeholder="" :step="1" step-strictly></el-input-number>
            </el-form-item>
            <el-form-item label="状态" prop="state">
                <el-select v-model="dataForm.state" placeholder="">
                  <el-option v-for="item in stateOptions" :label="item.dictLabel" :value="item.dictValue" :key="item.dictValue"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="dataForm.notes" type="textarea" placeholder="" :autosize="{minRows:5}"></el-input>
            </el-form-item>
        </el-form>
    </template>
    <template slot="footer">
        <el-button :disabled="ifSubmit" @click="submit" class="bcjx">保存</el-button>
    </template>
</myDrawer>
</template>

<script>
import {bqAdd,bqUpdate,bqDetail} from "@/api/bqgl.js";
export default {
    props:{
        isDrawer:{
            default:false,
            type:Boolean
        }
    },
    data() {
        return {
            ifSubmit:false,
            dataForm:{},
            rules:{
                bqValue:[
                    {required: true, message:'请输入', trigger: ['blur','change']}
                ],
                bqLabel:[
                    {required: true, message:'请输入', trigger: ['blur','change']}
                ],
                dbTable:[
                    {required: true, message:'请输入', trigger: ['blur','change']}
                ],
                sort:[
                    {required: true, message:'请输入', trigger: ['blur','change']}
                ],
                state:[
                    {required: true, message:'请选择', trigger: ['blur','change']}
                ]
            },
            stateOptions:[],
        }
    },
    created(){
        this.getState();
    },
    methods: {
        initForm(bqLxId,bqLxCode){
            this.dataForm=this.$options.data().dataForm;
            this.dataForm.bqLxId=bqLxId;
            this.dataForm.bqLxCode=bqLxCode;
            this.getState();
        },
        submit(){
            this.$refs.dataForm.validate(valid=>{
                if(valid){
                    this.ifSubmit = true;
                    if(this.dataForm.id){
                        bqUpdate(this.dataForm).then(res=>{
                            if(res && res.code==200){
                                this.msgSuccess('修改成功');
                                this.drawerClose();
                                this.ifSubmit=false;
                                this.$parent.refreshList();
                            }
                        }).catch(()=>{
                            this.ifSubmit=false
                        })
                    }else{
                        bqAdd(this.dataForm).then(res=>{
                            if(res && res.code==200){
                                this.msgSuccess('创建成功');
                                this.drawerClose();
                                this.ifSubmit=false;
                                this.$parent.refreshList();
                            }
                        }).catch(()=>{
                            this.ifSubmit=false
                        })
                    } 
                }
            })
        },
        // 获取状态
        getState(){
            this.getDicts("bq_xx_zt").then(res=>{
                if(res && res.code==200 && res.data){
                    this.stateOptions=res.data;
                }
            })
        },
        getDetail(id){
            this.getState();
            bqDetail({id}).then(res=>{
                if(res && res.code==200 && res.data){
                    this.dataForm=res.data;
                }
            })
        },
        drawerClose(){
            this.$emit('update:isDrawer');
        }
    }
}
</script>

<style lang="scss" scoped>
 /deep/ .footer {
    .bcjx {
        width: 120px;
        height: 40px;
        border-radius: 2px;
        background: rgba(12, 123, 242, 1);
        color: rgba(255, 255, 255, 1);
        font-family: OPPOSans;
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        padding: 0px;
        margin-left: 40px;
    }
}
</style>